const overrides = (palette, typography) => ({
  /* Styles applied to the root element. */
  root: {
    padding: "16px 24px"
  }
})

export default overrides
